import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ChevronRight } from "lucide-react";
import cities from "../../data/seo/cities.json";

/**
 * SEO city-link strip — sits between the FAQ and footer of /carservice.
 * Passes link equity from the high-traffic Google Ads LP to the
 * programmatic SEO city/service pages, and helps users discover that
 * we serve their city.
 *
 * Crawler-facing — light visual weight by design; conversion CTAs above
 * still own primary intent.
 */
const CarServiceCitiesStrip = () => (
  <section className="px-5 sm:px-8 py-10 sm:py-14 bg-slate-50 border-t border-slate-200">
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-7">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">
          Where we operate
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 leading-tight">
          Doorstep car service across {cities.length} cities
        </h2>
        <p className="text-sm sm:text-base text-slate-600 mt-2 max-w-xl mx-auto">
          Tap your city to see local pricing, available services and same-day slots.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2.5">
        {cities.map((c) => (
          <Link
            key={c.slug}
            to={`/car-service/${c.slug}`}
            data-testid={`lp-city-link-${c.slug}`}
            className="group inline-flex items-center justify-between gap-2 px-3.5 py-2.5 rounded-xl border border-slate-200 bg-white hover:border-blue-400 hover:bg-blue-50 transition-all text-sm font-semibold text-slate-700 hover:text-blue-700"
          >
            <span className="inline-flex items-center gap-1.5">
              <MapPin className="h-3.5 w-3.5 text-slate-400 group-hover:text-blue-500 shrink-0" />
              {c.name}
            </span>
            <ChevronRight className="h-3.5 w-3.5 opacity-40 group-hover:opacity-100 group-hover:text-blue-500" />
          </Link>
        ))}
      </div>

      <div className="mt-7 text-center">
        <Link
          to="/car-service"
          data-testid="lp-cities-hub-link"
          className="inline-flex items-center gap-1.5 text-sm font-bold text-blue-700 hover:text-blue-800"
        >
          View all coverage areas
          <ChevronRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  </section>
);

export default CarServiceCitiesStrip;
